import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './fonts/Chango Regular.ttf';

// Workaround for react error on browser back button in mobile safari
window.addEventListener("pageshow", function(evt){
  if(evt.persisted){
    setTimeout(function(){
      window.location.reload();
    },10);
  }
}, false);

console.log('Server: ', process.env.REACT_APP_API_URL);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);
